import { SearchX } from "lucide-react";

const EMPTY_IMG =
  "https://images.unsplash.com/photo-1620625515032-6ed0c1790c75?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHx2aW50YWdlJTIwcm9sZXglMjB3YXRjaCUyMG1hY3JvfGVufDB8fHx8MTc4MDY4NDg2OHww&ixlib=rb-4.1.0&q=85";

export default function EmptyState() {
  return (
    <div className="relative min-h-[420px] flex items-center justify-center overflow-hidden border border-white/5" data-testid="empty-state">
      <img src={EMPTY_IMG} alt="" className="absolute inset-0 w-full h-full object-cover opacity-[0.10]" />
      <div className="absolute inset-0 bg-gradient-to-br from-background via-background/80 to-transparent" />
      <div className="relative text-center px-6 py-16 max-w-md">
        <SearchX className="w-10 h-10 mx-auto text-gold/70 mb-6" />
        <h3 className="font-display text-2xl sm:text-3xl mb-4">Nessun lotto trovato</h3>
        <p className="text-white/50 text-sm leading-relaxed">
          Non abbiamo trovato nessun risultato per i parametri scelti. Prova ad ampliare la fascia di prezzo o il tempo rimanente, o a usare parole chiave diverse.
        </p>
      </div>
    </div>
  );
}
